export const CONCENTRATOR_MODEL_IDS = {
	10: 'Inogen One G4',
	11: 'Inogen One G5',
	12: 'Inogen Rove 4',
	13: 'Inogen Rove 6',
	14: 'OxyGo FIT',
	15: 'OxyGo NEXT (G5)',
	16: 'OxyGo FIT+',
	17: 'OxyGo NEXT (Rove 6)',
};
